import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-modal-text',
  templateUrl: './modal-text.component.html',
  styleUrls: ['./modal-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalTextComponent {}
